import { render, staticRenderFns } from "./TextLayer.vue?vue&type=template&id=5468e708&scoped=true"
import script from "./TextLayer.vue?vue&type=script&lang=js"
export * from "./TextLayer.vue?vue&type=script&lang=js"
import style0 from "./TextLayer.vue?vue&type=style&index=0&id=5468e708&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5468e708",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5468e708')) {
      api.createRecord('5468e708', component.options)
    } else {
      api.reload('5468e708', component.options)
    }
    module.hot.accept("./TextLayer.vue?vue&type=template&id=5468e708&scoped=true", function () {
      api.rerender('5468e708', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/psd-layers/layer-views/TextLayer.vue"
export default component.exports